module.exports = __webpack_public_path__ + "media/move_together.a24dd666.mp3";